import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/media/avatars/150-6.jpg'
import _imports_1 from '@/assets/media/svg/files/pdf.svg'
import _imports_2 from '@/assets/media/svg/files/doc.svg'
import _imports_3 from '@/assets/media/svg/files/css.svg'


const _hoisted_1 = { class: "timeline-item" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_3 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_4 = { class: "symbol-label bg-light" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 svg-icon-gray-500" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "timeline-content mb-10 mt-n1" }, [
  /*#__PURE__*/_createVNode("div", { class: "mb-5 pe-3" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "#",
      class: "fs-5 fw-bold text-gray-800 text-hover-primary mb-2"
    }, "3 New Incoming Project Files:"),
    /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center mt-1 fs-6" }, [
      /*#__PURE__*/_createVNode("div", { class: "text-muted me-2 fs-7" }, "Sent at 10:30 PM by"),
      /*#__PURE__*/_createVNode("div", {
        class: "symbol symbol-circle symbol-25px",
        "data-bs-toggle": "tooltip",
        "data-bs-boundary": "window",
        "data-bs-placement": "top",
        title: "Jan Hummer"
      }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_0,
          alt: "img"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "overflow-auto pb-5" }, [
    /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-5" }, [
      /*#__PURE__*/_createVNode("div", { class: "d-flex flex-aligns-center pe-10 pe-lg-20" }, [
        /*#__PURE__*/_createVNode("img", {
          alt: "",
          class: "w-30px me-3",
          src: _imports_1
        }),
        /*#__PURE__*/_createVNode("div", { class: "ms-1 fw-bold" }, [
          /*#__PURE__*/_createVNode("a", {
            href: "#",
            class: "fs-6 text-hover-primary fw-bolder"
          }, "Finance KPI App Guidelines"),
          /*#__PURE__*/_createVNode("div", { class: "text-gray-400" }, "1.9mb")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "d-flex flex-aligns-center pe-10 pe-lg-20" }, [
        /*#__PURE__*/_createVNode("img", {
          alt: "",
          class: "w-30px me-3",
          src: _imports_2
        }),
        /*#__PURE__*/_createVNode("div", { class: "ms-1 fw-bold" }, [
          /*#__PURE__*/_createVNode("a", {
            href: "#",
            class: "fs-6 text-hover-primary fw-bolder"
          }, "Client UAT Testing Results"),
          /*#__PURE__*/_createVNode("div", { class: "text-gray-400" }, "18kb")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "d-flex flex-aligns-center" }, [
        /*#__PURE__*/_createVNode("img", {
          alt: "",
          class: "w-30px me-3",
          src: _imports_3
        }),
        /*#__PURE__*/_createVNode("div", { class: "ms-1 fw-bold" }, [
          /*#__PURE__*/_createVNode("a", {
            href: "#",
            class: "fs-6 text-hover-primary fw-bolder"
          }, "Finance Reports"),
          /*#__PURE__*/_createVNode("div", { class: "text-gray-400" }, "20mb")
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, { src: "@/assets/media/icons/duotone/General/Attachment2.svg" })
        ])
      ])
    ]),
    _hoisted_6
  ]))
}